import React from 'react'

const FolderIcon = props => (
  <div {...props}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="23.815"
      height="29.519"
      viewBox="0 0 23.815 29.519"
    >
      <g transform="translate(0.5 0.5)">
        <path
          d="M20.26,3H8.852A2.852,2.852,0,0,0,6,5.852V28.667a2.852,2.852,0,0,0,2.852,2.852H25.963a2.852,2.852,0,0,0,2.852-2.852V11.556Z"
          transform="translate(-6 -3)"
          fill="none"
          stroke={props.fill}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        />
        <path
          d="M21,3v8.556h8.556"
          transform="translate(-6.74 -3)"
          fill="none"
          stroke={props.fill}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        />
        <path
          d="M23.408,19.5H12"
          transform="translate(-6.296 -3.815)"
          fill="none"
          stroke={props.fill}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        />
        <path
          d="M23.408,25.5H12"
          transform="translate(-6.296 -4.111)"
          fill="none"
          stroke={props.fill}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        />
        <path
          d="M14.852,13.5H12"
          transform="translate(-6.296 -3.518)"
          fill="none"
          stroke={props.fill}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        />
      </g>
    </svg>
  </div>
)

export default FolderIcon
